import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { AttendancePolicyData, CommonReducerAction, setHelperText } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import FloatValues from "../../../../../Component/FloatValues";
import InputValues from "../../../../../Component/InputValues";
import { InitialData } from "./InitialData";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
class Punctuality extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ispunctualityrule: false,
      attendancepolicyid: null,
      notUnique: false,
      exceedinggracetypeid: 1,
      punctualitytypeid: 1,
      gracehourtime: "00:00",
      penaltytypeid: null,
      penaltyleaveid: { displayname: null, displayvalue: null },
      penaltyleavecount: 0,
      penaltyactiontypeid: null,
      gracedaycount: 0,
      gracetime: "00:00",
      gracetimelimit: 0,
      exceedgracedaycount: 0,
      breachleavecount: 0,
      hours: 0,
      minutes: 0,
      hourslimit: 0,
      minuteslimit: 0,
      grhrhours: 0,
      grhrminutes: 0,
      LeaveType: props.LeaveType,
      callatebytypeid: 2,
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    this.props.ChangeLanguage("attendancepolicy,navigation");
    let penaltyleaveid;
    const punctualityObject = this.props.InitAttendancePolicy.punctuality;
    Object.keys(this.state).map((key) => {
      if (key == "gracetime") {
        if (punctualityObject[key]) {
          const hoursminutes = punctualityObject[key].split(":");
          this.state.hours = hoursminutes[0];
          this.state.minutes = hoursminutes[1];
        }
      } else if (key == "gracehourtime") {
        if (punctualityObject[key]) {
          const hoursminutes = punctualityObject[key].split(":");
          this.state.grhrhours = hoursminutes[0];
          this.state.grhrminutes = hoursminutes[1];
        }
      } else if (key == "gracetimelimit") {
        if (punctualityObject[key]) {
          const hoursminutes = punctualityObject[key].split(":");
          this.state.hourslimit = hoursminutes[0];
          this.state.minuteslimit = hoursminutes[1];
        }
      } else if (key == "penaltyleaveid") {
        penaltyleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == punctualityObject.penaltyleaveid,
        );
      } else {
        this.state[key] = punctualityObject[key] !== undefined
          ? punctualityObject[key]
          : this.state[key];
      }
    });
    this.setState({
      penaltyleaveid,
      ispunctualityrule: this.props.InitAttendancePolicy.ispunctualityrule,
      callatebytypeid: this.props.InitAttendancePolicy.callatebytypeid || 2,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(4, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  validateNext = () => {
    let isError = false;
    if (this.state.ispunctualityrule) {
      if (!this.state.punctualitytypeid) {
        this.showError("Please select punctuality type");
        isError = true;
      } else {
        switch (this.state.punctualitytypeid) {
          case 1:
            if (
              Number(this.state.grhrhours) == 0
              && Number(this.state.grhrminutes) == 0
            ) {
              this.showError("Please add grace hours and minutes");
              isError = true;
            }
            break;
          case 2:
            if (
              Number(this.state.hourslimit) == 0
              && Number(this.state.minuteslimit) == 0
            ) {
              // this.showError("Please select grace time limit");
              // isError = true;
            } else if (this.state.gracedaycount == 0) {
              this.showError("Please add grace day count");
              isError = true;
            } else if (
              Number(this.state.hours) == 0
              && Number(this.state.minutes) == 0
            ) {
              this.showError("Please add grace hour and minute");
              isError = true;
            } else if (this.state.exceedgracedaycount <= 0) {
              this.showError("Please add an exceed grace day count");
              isError = true;
            }
            if (this.state.penaltytypeid == 2) {
              if (this.state.breachleavecount == 0) {
                this.showError("Please add a breach leave count");
                isError = true;
              }
            }
            break;
          default:
            break;
        }
        if (!this.state.penaltytypeid) {
          this.showError("Please select a penalty for exceeding grace");
          isError = true;
        }
        if (this.state.penaltytypeid == 1 || this.state.penaltytypeid == 2) {
          if (!this.state.penaltyleaveid) {
            this.showError("Please select a leave type");
            isError = true;
          } else if (this.state.penaltyleavecount == 0) {
            this.showError("Please add leave count");
            isError = true;
          } else if (!this.state.penaltyactiontypeid) {
            this.showError("Please select a deduction policy");
            isError = true;
          }
        }
      }
    }
    this.props.StepError(4, isError);
    if (isError) return false;
    this.props.click();
  }

  showError = (error) => {
    this.props.enqueueSnackbar(error, { variant: "error" });
  };

  handleChange(name, arg, event) {
    switch (name) {
      case "ispunctualityrule": {
        this.setState({ ispunctualityrule: arg }, () => {
          !this.state.ispunctualityrule
            ? this.ClearAll()
            : this.UpdateReducer();
        });
        break;
      }
      case "punctualitytypeid": {
        if (this.state.punctualitytypeid == arg) return false;
        this.setState(
          {
            punctualitytypeid: arg,
            hours: 0,
            minutes: 0,
            hourslimit: 0,
            minuteslimit: 0,
            penaltyleaveid: { displayname: null, displayvalue: null },
            penaltyleavecount: 0,
            gracedaycount: 0,
            exceedgracedaycount: 0,
            breachleavecount: 0,
          },
          () => this.ClearAll(),
        );
        break;
      }
      case "penaltytypeid": {
        this.setState(
          {
            penaltytypeid: arg,
            penaltyleaveid: null,
            penaltyactiontypeid: null,
            penaltyleavecount: 0,
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      case "penaltyleaveid": {
        if (arg == this.state.penaltyleaveid) return false;
        this.setState({ penaltyleaveid: arg, penaltyleavecount: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "penaltyactiontypeid": {
        this.setState({ penaltyactiontypeid: arg }, () => this.UpdateReducer());
        break;
      }
      case "exceedinggracetypeid": {
        this.setState({ exceedinggracetypeid: arg }, () => {
          this.UpdateReducer();
        });
        break;
      }

      case "callatebytypeid": {
        this.setState({ callatebytypeid: arg }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "gracetimelimit":
      case "gracehourtime":
      case "gracedaycount":
      case "grhrhours":
      case "grhrminutes":
      case "hours":
      case "minutes":
      case "hourslimit":
      case "minuteslimit":
      case "gracetime":
        this.HourMinuteKeyChange(name, arg, event);
        break;
      case "exceedgracedaycount":
      case "breachleavecount":
      case "penaltyleavecount":
        this.CommonNumberChange(name, arg, event);
        break;
      default:
        break;
    }
  }

  CommonNumberChange = (name, max, event) => {
    let value;
    if (
      Number(event.target.value) > Number(max)
      || Number.isNaN(event.target.value)
      || Math.sign(event.target.value) == -1
    ) {
      value = this.state[name];
    } else value = event.target.value;
    this.setState({ [name]: Number(value) }, () => this.UpdateReducer());
  };

  HourMinuteKeyChange = (name, arg, event) => {
    const numbers = /^[0-9]+$/;
    let value = 0;
    if (event.target.value.match(numbers)) {
      if (Number(event.target.value) > Number(arg)) value = this.state[name];
      else {
        value = Number(event.target.value);
        if (value < 10) {
          value = `0${value}`;
        }
      }
      this.setState({ [name]: Math.floor(value) }, () => this.UpdateReducer());
    } else {
      this.setState({ [name]: Math.floor(this.state[name]) });
    }
  };

  ClearAll = () => {
    this.setState(
      {
        ...InitialData.punctuality,
        punctualitytypeid: this.state.punctualitytypeid,
        hours: 0,
        minutes: 0,
        hourslimit: 0,
        minuteslimit: 0,
      },
      () => this.UpdateReducer(),
    );
  };

  UpdateReducer = () => {
    this.props.AttendancePolicyData({
      ...this.props.InitAttendancePolicy,
      ...{
        ispunctualityrule: this.state.ispunctualityrule,
        callatebytypeid: this.state.callatebytypeid,
        punctuality: {
          punctualitytypeid: this.state.punctualitytypeid,
          exceedinggracetypeid: this.state.exceedinggracetypeid,
          gracehourtime: `${this.state.grhrhours}:${this.state.grhrminutes}`,
          penaltytypeid: this.state.penaltytypeid,
          penaltyleaveid: this.state.penaltyleaveid
            ? this.state.penaltyleaveid.displayvalue
            : null,
          penaltyleavename: this.state.penaltyleaveid
            ? this.state.penaltyleaveid.displayname
            : null,
          penaltyleavecount: this.state.penaltyleavecount,
          penaltyactiontypeid: this.state.penaltyactiontypeid,
          gracedaycount: this.state.gracedaycount,
          gracetime: `${this.state.hours}:${this.state.minutes}`,
          gracetimelimit: `${this.state.hourslimit}:${this.state.minuteslimit}`,
          exceedgracedaycount: this.state.exceedgracedaycount,
          breachleavecount: this.state.breachleavecount,
        },
      },
    });
  };

  RenderLeaveDeduct = () => (
    <div>
      <li>
        <p className="form-input-label">
          <FormattedMessage
            id="LbChooseleavetype"
            defaultMessage="Choose leave type "
          />
        </p>
        <span className="width200p">
          <Select
            autofocus
            placeholder="Select"
            options={this.state.LeaveType}
            getOptionLabel={(option) => option.displayname}
            getOptionValue={(option) => option.displayvalue}
            onChange={this.handleChange.bind(this, "penaltyleaveid")}
            value={this.state.penaltyleaveid}
            className="width200p"
          />
        </span>
      </li>
      <li className="margin-top-20">
        <p className="form-input-label">
          <FormattedMessage
            id="LbNumberLeaveDeduct"
            defaultMessage="Number of leaves to deduct"
          />
        </p>
        <FloatValues
          min="0"
          max="31"
          step="0.25"
          field="penaltyleavecount"
          onChange={this.handleChange.bind(this, "penaltyleavecount", 31)}
          value={this.state.penaltyleavecount}
          defaultvalue={this.state.penaltyleavecount}
        />
      </li>
    </div>
  );

  RenderLeaveDeductionPolicy = () => (
    <li className="margin-top-10">
      <p className="form-input-label">
        <FormattedMessage
          id="LbDeductionPolicy"
          defaultMessage="Deduction Policy"
        />
      </p>
      {/* <ul className="padding-left-20">
                    <li> */}
      <div
        className="depedent-select-list"
        onClick={() => this.handleChange("penaltyactiontypeid", 2)}
        aria-expanded={this.state.penaltyactiontypeid == 2}
      >
        <div style={{ width: "90%", display: "inline-block" }}>
          <FormattedMessage
            id="LbExceedingGraceHours"
            defaultMessage="Deduct automatically and notify employee, approvers and admin"
          />
        </div>
        {this.state.penaltyactiontypeid == 2 ? (
          <div
            className="floatright margin-top-10"
            style={{ display: "inline-block" }}
          >
            <img src={CheckImg} height="20" />
          </div>
        ) : (
            <div className="not-selected margin-top-10"></div>
          )}
      </div>
      {/* </li>
                    <li> */}
      <div
        className="depedent-select-list"
        onClick={() => this.handleChange("penaltyactiontypeid", 1)}
        aria-expanded={this.state.penaltyactiontypeid == 1}
      >
        <div style={{ width: "90%", display: "inline-block" }}>
          <FormattedMessage
            id="LbExceedingGraceHoursAuto"
            defaultMessage="Automatically send a leave request on behalf of the employee, using the leave approval workflow"
          />
        </div>
        {this.state.penaltyactiontypeid == 1 ? (
          <div
            className="floatright margin-top-10"
            style={{ display: "inline-block" }}
          >
            <img src={CheckImg} height="20" />
          </div>
        ) : (
            <div className="not-selected margin-top-10"></div>
          )}
      </div>
      {/* </li>
                </ul> */}
    </li>
  );

  render() {
    const language = this.props.Language.attendancepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content width80">
            <p className="input-form-label"></p>
            <div className="padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbPunctuality"
                  defaultMessage="Do you wish to identify/track or penalize late-comers in any way ?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("ispunctualityrule", true)}
                aria-expanded={this.state.ispunctualityrule}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.ispunctualityrule ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected"></span>
                  )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.ispunctualityrule}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  {/* Start LbExceedingGraceHours */}
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("punctualitytypeid", 1)}
                    aria-expanded={this.state.punctualitytypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="LbExceedingGraceHoursLate"
                        defaultMessage="Late marks will be counted on exceeding grace hours"
                      />
                    </span>
                    {this.state.punctualitytypeid == 1 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected"></span>
                      )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.punctualitytypeid == 1}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial "
                    >
                      <ul>
                        <li className="margin-bottom-8">
                          <span>
                            <FormattedMessage
                              id="LbMonthlyGrace"
                              defaultMessage="Monthly grace hours employees get is"
                            />
                            <span className="width200p">
                              <InputValues
                                min="0"
                                max="100"
                                field="grhrhours"
                                pattern="[0-9]"
                                onkeypress="{return !(event.charCode == 46)}"
                                onChange={this.handleChange.bind(
                                  this,
                                  "grhrhours",
                                  100,
                                )}
                                value={this.state.grhrhours}
                                defaultvalue={this.state.grhrhours}
                              />
                              {/* <span className='number-wrapper'>
                                                                <input
                                                                    className="seatlimit"
                                                                    type="number"
                                                                    max="11"
                                                                    min="0"
                                                                    pattern="[0-9]"
                                                                    onkeypress="{return !(event.charCode == 46)}"
                                                                    onChange={this.handleChange.bind(this, "gracehourtime", "grhrhours")}
                                                                    value={this.state.grhrhours}
                                                                />
                                                            </span> */}
                            </span>
                            <FormattedMessage
                              id="LbHours"
                              defaultMessage="hours"
                            />
                            <InputValues
                              min="0"
                              max="59"
                              field="grhrminutes"
                              onChange={this.handleChange.bind(
                                this,
                                "grhrminutes",
                                59,
                              )}
                              value={this.state.grhrminutes}
                              defaultvalue={this.state.grhrminutes}
                            />
                            {/* <span className='number-wrapper'>
                                                            <span className='number-wrapper'>
                                                                <input
                                                                    className="seatlimit"
                                                                    type="number"
                                                                    min="0"
                                                                    max="59"
                                                                    onChange={this.handleChange.bind(this, "gracehourtime", "grhrminutes", 59)}
                                                                    value={this.state.grhrminutes}
                                                                />
                                                            </span>
                                                        </span> */}
                            <FormattedMessage
                              id="LbMinutes"
                              defaultMessage="minutes"
                            />
                          </span>
                        </li>

                        <li className="margin-bottom-20">
                          <span>
                            <FormattedMessage
                              id="LbGraceTrigger"
                              defaultMessage="Each grace count must trigger after"
                            />
                            <br />
                            <span className="width200p">
                              <InputValues
                                min="0"
                                max="11"
                                field="hours"
                                pattern={"[0-9]+(.[0-9][0-9]?)?"}
                                onChange={this.handleChange.bind(
                                  this,
                                  "hours",
                                  11,
                                )}
                                value={this.state.hours}
                                defaultvalue={this.state.hours}
                              />
                              {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max="11"
                                                                            onChange={this.handleChange.bind(this, "gracetime", "hours")}
                                                                            value={this.state.hours}
                                                                            pattern={"[0-9]+(\.[0-9][0-9]?)?"}
                                                                        />
                                                                    </span> */}
                            </span>
                            <FormattedMessage
                              id="LbHours"
                              defaultMessage="hours"
                            />
                            <InputValues
                              min="0"
                              max="59"
                              field="minutes"
                              onChange={this.handleChange.bind(
                                this,
                                "minutes",
                                59,
                              )}
                              value={this.state.minutes}
                              defaultvalue={this.state.minutes}
                            />
                            {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max="59"
                                                                            onChange={this.handleChange.bind(this, "gracetime", "minutes")}
                                                                            value={this.state.minutes}
                                                                        />
                                                                    </span> */}

                            <FormattedMessage
                              id="LbMinutes"
                              defaultMessage="minutes"
                            />
                            <br />
                            <span className="margin-top-8 display-block">
                              <FormattedMessage
                                id="LbMustNotExceed"
                                defaultMessage="but must not exceed"
                              />
                              {/* <span className='number-wrapper'>
                                                                <span className='number-wrapper'>
                                                                    <input
                                                                        className="seatlimit"
                                                                        type="number"
                                                                        min="0"
                                                                        max={this.state.gracedaycount}
                                                                        onChange={this.handleChange.bind(this, "gracetimelimit")}
                                                                        value={this.state.gracetimelimit}
                                                                    />
                                                                </span>
                                                            </span> */}
                              <span className="width200p">
                                <InputValues
                                  min="0"
                                  max="11"
                                  field="hourslimit"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "hourslimit",
                                    11,
                                  )}
                                  value={this.state.hourslimit}
                                  defaultvalue={this.state.hourslimit}
                                />
                                {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max={this.state.hours}
                                                                            onChange={this.handleChange.bind(this, "gracetimelimit", "hourslimit")}
                                                                            value={this.state.hourslimit}
                                                                        />
                                                                    </span> */}
                              </span>
                              <FormattedMessage
                                id="LbHours"
                                defaultMessage="hours"
                              />
                              <InputValues
                                min="0"
                                max="59"
                                field="minuteslimit"
                                onChange={this.handleChange.bind(
                                  this,
                                  "minuteslimit",
                                  59,
                                )}
                                value={this.state.minuteslimit}
                                defaultvalue={this.state.minuteslimit}
                              />
                              {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max={this.state.minutes}
                                                                            onChange={this.handleChange.bind(this, "gracetimelimit", "minuteslimit")}
                                                                            value={this.state.minuteslimit}
                                                                        />
                                                                    </span> */}
                              <FormattedMessage
                                id="LbMinutes"
                                defaultMessage="minutes"
                              />
                              &nbsp;
                              <FormattedMessage
                                id="LbMaxLimit"
                                defaultMessage="max limit"
                              />
                            </span>
                          </span>
                        </li>
                        <li>
                          <span className="display-block margin-bottom-8">
                            <FormattedMessage
                              id="LbPenalty"
                              defaultMessage="What will be the penalty on late-marks after exhausting the Grace hours"
                            />
                          </span>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 1)
                            }
                            aria-expanded={this.state.penaltytypeid == 1}
                          >
                            <span>
                              <FormattedMessage
                                id="LbRefillGrace"
                                defaultMessage="Deduct leaves and refill grace hours back to full capacity"
                              />
                            </span>
                            {this.state.penaltytypeid == 1 ? (
                              <span className="floatright">
                                <img src={CheckImg} height="20" />
                              </span>
                            ) : (
                                <span className="not-selected"></span>
                              )}
                          </div>
                          <div className="et-level4">
                            <Collapse
                              in={this.state.penaltytypeid == 1}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div>
                                <ul>
                                  {this.RenderLeaveDeduct()}
                                  {this.RenderLeaveDeductionPolicy()}
                                </ul>
                              </div>
                            </Collapse>
                          </div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 2)
                            }
                            aria-expanded={this.state.penaltytypeid == 2}
                          >
                            <div
                              style={{ width: "95%", display: "inline-block" }}
                            >
                              <FormattedMessage
                                id="LbDontRefill"
                                defaultMessage="Deduct leaves but do not refill grace hours, and consider every following Late-Mark eligible for deduction too (till month end), as per below:"
                              />
                            </div>
                            {this.state.penaltytypeid == 2 ? (
                              <div className="floatright margin-top-20">
                                <img src={CheckImg} height="20" />
                              </div>
                            ) : (
                                <div className="not-selected margin-top-20"></div>
                              )}
                          </div>
                          <div className="et-level4">
                            <Collapse
                              in={this.state.penaltytypeid == 2}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div>
                                <ul>
                                  {this.RenderLeaveDeduct()}
                                  {this.RenderLeaveDeductionPolicy()}
                                </ul>
                              </div>
                            </Collapse>
                          </div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 3)
                            }
                            aria-expanded={this.state.penaltytypeid == 3}
                          >
                            <div
                              style={{ width: "95%", display: "inline-block" }}
                            >
                              <FormattedMessage
                                id="LbNoPenalty"
                                defaultMessage="No penalty or deductions for exhausting Grace hours. Just record the Late-Marks based on the Grace hours configured."
                              />
                            </div>
                            {this.state.penaltytypeid == 3 ? (
                              <div
                                style={{ display: "inline-block" }}
                                className="floatright margin-top-10"
                              >
                                <img src={CheckImg} height="20" />
                              </div>
                            ) : (
                                <div className="not-selected margin-top-10"></div>
                              )}
                          </div>
                        </li>
                      </ul>
                    </Collapse>
                  </div>
                  {/* End LbExceedingGraceHours */}
                  {/* Start LbExceedingGraceCounts */}
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("punctualitytypeid", 2)}
                    aria-expanded={this.state.punctualitytypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbLateMark"
                        defaultMessage="Late marks will be counted on exceeding grace counts"
                      />
                    </span>
                    {this.state.punctualitytypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected"></span>
                      )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.punctualitytypeid == 2}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <ul>
                        <li>
                          <span>
                            <FormattedMessage
                              id="LbGraceInAMonth"
                              defaultMessage="Number of grace counts available in a month is"
                            />
                            <InputValues
                              min="0"
                              max="30"
                              field="gracedaycount"
                              onChange={this.handleChange.bind(
                                this,
                                "gracedaycount",
                                30,
                              )}
                              value={this.state.gracedaycount}
                              defaultvalue={this.state.gracedaycount}
                            />
                            {/* <span className='number-wrapper'>
                                                            <input
                                                                className="seatlimit"
                                                                type="number"
                                                                min="0"
                                                                max="30"
                                                                onChange={this.handleChange.bind(this, "gracedaycount", "gracedaycount")}
                                                                value={this.state.gracedaycount}
                                                            />
                                                        </span> */}
                            <FormattedMessage
                              id="LbCounts"
                              defaultMessage="counts"
                            />
                          </span>
                          <ul className="margin-bottom-16">
                            <li>
                              <span>
                                <FormattedMessage
                                  id="LbGraceTrigger"
                                  defaultMessage="Each grace count must trigger after"
                                />
                                <br />
                                <span className="width200p">
                                  <InputValues
                                    min="0"
                                    max="11"
                                    field="hours"
                                    pattern={"[0-9]+(.[0-9][0-9]?)?"}
                                    onChange={this.handleChange.bind(
                                      this,
                                      "hours",
                                      11,
                                    )}
                                    value={this.state.hours}
                                    defaultvalue={this.state.hours}
                                  />
                                  {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max="11"
                                                                            onChange={this.handleChange.bind(this, "gracetime", "hours")}
                                                                            value={this.state.hours}
                                                                            pattern={"[0-9]+(\.[0-9][0-9]?)?"}
                                                                        />
                                                                    </span> */}
                                </span>
                                <FormattedMessage
                                  id="LbHours"
                                  defaultMessage="hours"
                                />
                                <InputValues
                                  min="0"
                                  max="59"
                                  field="minutes"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "minutes",
                                    59,
                                  )}
                                  value={this.state.minutes}
                                  defaultvalue={this.state.minutes}
                                />
                                {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max="59"
                                                                            onChange={this.handleChange.bind(this, "gracetime", "minutes")}
                                                                            value={this.state.minutes}
                                                                        />
                                                                    </span> */}
                                <FormattedMessage
                                  id="LbMinutes"
                                  defaultMessage="minutes"
                                />
                                <span className="margin-top-8 display-block">
                                  <FormattedMessage
                                    id="LbMustNotExceed"
                                    defaultMessage="but must not exceed"
                                  />
                                  {/* <span className='number-wrapper'>
                                                                <span className='number-wrapper'>
                                                                    <input
                                                                        className="seatlimit"
                                                                        type="number"
                                                                        min="0"
                                                                        max={this.state.gracedaycount}
                                                                        onChange={this.handleChange.bind(this, "gracetimelimit")}
                                                                        value={this.state.gracetimelimit}
                                                                    />
                                                                </span>
                                                            </span> */}
                                  <span className="width200p">
                                    <InputValues
                                      min="0"
                                      max="11"
                                      field="hourslimit"
                                      onChange={this.handleChange.bind(
                                        this,
                                        "hourslimit",
                                        11,
                                      )}
                                      value={this.state.hourslimit}
                                      defaultvalue={this.state.hourslimit}
                                    />
                                    {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max={this.state.hours}
                                                                            onChange={this.handleChange.bind(this, "gracetimelimit", "hourslimit")}
                                                                            value={this.state.hourslimit}
                                                                        />
                                                                    </span> */}
                                  </span>
                                  <FormattedMessage
                                    id="LbHours"
                                    defaultMessage="hours"
                                  />
                                  <InputValues
                                    min="0"
                                    max="59"
                                    field="minuteslimit"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "minuteslimit",
                                      59,
                                    )}
                                    defaultvalue={this.state.minuteslimit}
                                    value={this.state.minuteslimit}
                                  />
                                  {/* <span className='number-wrapper'>
                                                                        <input
                                                                            className="seatlimit"
                                                                            type="number"
                                                                            min="0"
                                                                            max={this.state.minutes}
                                                                            onChange={this.handleChange.bind(this, "gracetimelimit", "minuteslimit")}
                                                                            value={this.state.minuteslimit}
                                                                        />
                                                                    </span> */}
                                  <FormattedMessage
                                    id="LbMinutes"
                                    defaultMessage="minutes"
                                  />
                                  &nbsp;
                                  <FormattedMessage
                                    id="LbMaxLimit"
                                    defaultMessage="max limit"
                                  />
                                </span>
                              </span>
                            </li>
                          </ul>
                          <ul className="margin-bottom-16">
                            <li>
                              <span>
                                <FormattedMessage
                                  id="LbExceedmaxLimit"
                                  defaultMessage="Exceeding max limit will be considered as additional"
                                />
                                <br />
                                <InputValues
                                  min="0"
                                  max="30"
                                  field="exceedgracedaycount"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "exceedgracedaycount",
                                    30,
                                  )}
                                  value={this.state.exceedgracedaycount}
                                  defaultvalue={this.state.exceedgracedaycount}
                                />
                                {/* <span className='number-wrapper'>
                                                                                <input
                                                                                    className="seatlimit"
                                                                                    type="number"
                                                                                    min="0"
                                                                                    max="30"
                                                                                    onChange={this.handleChange.bind(this, "exceedgracedaycount", 30)}
                                                                                    value={this.state.exceedgracedaycount}
                                                                                />
                                                                            </span> */}
                                <FormattedMessage
                                  id="LbGraceCount"
                                  defaultMessage="grace count usage"
                                />
                                .
                              </span>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <span className="display-block margin-bottom-8">
                            <FormattedMessage
                              id="LbPenaltyAfterGraceCounts"
                              defaultMessage="What will be the penalty after exceeding the grace counts available in a month?"
                            />
                          </span>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 1)
                            }
                            aria-expanded={this.state.penaltytypeid == 1}
                          >
                            <div
                              style={{ width: "95%", display: "inline-block" }}
                            >
                              <FormattedMessage
                                id="LbRefillBack"
                                defaultMessage="Deduct leaves and refill the grace counts back to full capacity"
                              />
                            </div>
                            {this.state.penaltytypeid == 1 ? (
                              <div
                                style={{ display: "inline-block" }}
                                className="floatright"
                              >
                                <img src={CheckImg} height="20" />
                              </div>
                            ) : (
                                <div
                                  style={{ display: "inline-block" }}
                                  className="not-selected"
                                ></div>
                              )}
                          </div>
                          <div className="et-level4">
                            <Collapse
                              in={this.state.penaltytypeid == 1}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div>
                                <ul>
                                  {this.RenderLeaveDeduct()}
                                  {this.RenderLeaveDeductionPolicy()}
                                </ul>
                              </div>
                            </Collapse>
                          </div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 2)
                            }
                            aria-expanded={this.state.penaltytypeid == 2}
                          >
                            <div
                              style={{ width: "95%", display: "inline-block" }}
                            >
                              <FormattedMessage
                                id="LbConsiderFollowingLate"
                                defaultMessage="Deduct leaves but do not refill grace counts, and consider every following breach as a Late-Mark eligible for deduction too (till month end), as per below:"
                              />
                            </div>
                            {this.state.penaltytypeid == 2 ? (
                              <div
                                style={{ display: "inline-block" }}
                                className="floatright margin-top-20"
                              >
                                <img src={CheckImg} height="20" />
                              </div>
                            ) : (
                                <div className="not-selected margin-top-20"></div>
                              )}
                          </div>
                          <div className="et-level4">
                            <Collapse
                              in={this.state.penaltytypeid == 2}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div>
                                <ul>
                                  {this.RenderLeaveDeduct()}
                                  <li className="margin-top-20">
                                    <span>
                                      <FormattedMessage
                                        id="LbLeavesToDeduct"
                                        defaultMessage="Number of leaves to deduct per Late day after the first time"
                                      />
                                      <br />
                                      {/* <InputValues
                                        min="0"
                                        max="30"
                                        field="breachleavecount"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "breachleavecount",
                                          30,
                                        )}
                                        value={this.state.breachleavecount}
                                        defaultvalue={
                                          this.state.breachleavecount
                                        }
                                      /> */}
                                      <FloatValues
                                        min="0"
                                        max="30"
                                        step="0.5"
                                        field="breachleavecount"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "breachleavecount",
                                          30,
                                        )}
                                        value={this.state.breachleavecount}
                                        defaultvalue={
                                          this.state.breachleavecount
                                        }
                                      />
                                      {/* <span className='number-wrapper'>
                                                                                <input
                                                                                    className="seatlimit"
                                                                                    type="number"
                                                                                    min="0"
                                                                                    max="30"
                                                                                    onChange={this.handleChange.bind(this, "breachleavecount", 30)}
                                                                                    value={this.state.breachleavecount}
                                                                                />
                                                                            </span> */}
                                    </span>
                                  </li>
                                  {this.RenderLeaveDeductionPolicy()}
                                </ul>
                              </div>
                            </Collapse>
                          </div>
                          <div
                            className="depedent-select-list"
                            onClick={() =>
                              this.handleChange("penaltytypeid", 3)
                            }
                            aria-expanded={this.state.penaltytypeid == 3}
                          >
                            <div
                              style={{ width: "95%", display: "inline-block" }}
                            >
                              <FormattedMessage
                                id="LbRecordLateMark"
                                defaultMessage="No penalty or deductions for exhausting Grace counts. Just record the Late-Marks based on the grace count's configured breach-time limit."
                              />
                            </div>
                            {this.state.penaltytypeid == 3 ? (
                              <div
                                style={{ display: "inline-block" }}
                                className="floatright margin-top-10"
                              >
                                <img src={CheckImg} height="20" />
                              </div>
                            ) : (
                                <div className="not-selected  margin-top-10"></div>
                              )}
                          </div>
                        </li>
                      </ul>
                    </Collapse>
                  </div>
                  {/* End LbExceedingGraceCounts */}
                </Collapse>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("ispunctualityrule", false)}
                aria-expanded={!this.state.ispunctualityrule}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {!this.state.ispunctualityrule ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected"></span>
                  )}
              </div>
            </div>
          </div>
          {/* <div className="padding-bottom-30 stepper-scroller-content width80">
            <p className="input-form-label"></p>
            <div className="padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbCalculateTime"
                  defaultMessage="How do you want to calculate late time ?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("callatebytypeid", 1)}
                aria-expanded={this.state.callatebytypeid}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.callatebytypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected"></span>
                  )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("callatebytypeid", 2)}
                aria-expanded={!this.state.callatebytypeid}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.callatebytypeid == 2 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected"></span>
                  )}
              </div>
            </div>
          </div> */}

        </div>
      </IntlProvider>
    );
  }
}
Punctuality.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Punctuality)));
